import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { vdom } from 'src/domains/App';
import { initIndex } from 'src/index.init';
import { ClientApi } from 'src/appState/ClientApi';
import { registerNetworRequest, whenIdle } from 'src_common/utils/Idle';
import { AppState } from './appState/AppState';

const createJsx = async (): Promise<[React.ReactElement | null, AppState]> => {
    const common = await initIndex();
    const appState = new AppState(common);
    return [vdom(common, appState), appState];
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
createJsx().then(([app, appState]) => {
    //@ts-expect-error
    window.$appState = appState;
    // @ts-expect-error
    window.$clientApi = new ClientApi(appState.common);

    const unregister = registerNetworRequest();

    setTimeout(() => {
        unregister();
    }, 500);

    whenIdle(async () => {
        const root = document.getElementById('root');

        if (root === null) {
            console.error('Missing root');
        } else {
            hydrateRoot(root, app);
        }
    });
});
